<ngx-spinner
  bdColor = "rgba(51, 51, 51, 0.8)"
  size = "medium"
  color = "#fff"
  type = "ball-clip-rotate"></ngx-spinner>
<router-outlet></router-outlet>
<app-footer></app-footer>
